/* ===========================================================================
   Catharine Hill — LP da loja internacional oficial dentro da MKPBR
   Criada em 19/09/2026 no molde da Popozuda: vitrine, ficha do produto,
   carrinho proprio, busca local, seletores e faixa de mercado — mais o que a
   home oficial da marca tem: carrossel do banner com tracos, prateleiras em
   carrossel com setas por fora, circulos de categoria, cartoes, blog.

   DEGRAUS DO DESCONTO: 2 itens = 5%, 3 = 10%, 4+ = 15%, contando o TOTAL DE
   ITENS DO CARRINHO (soma produtos diferentes). Quem APLICA e o app Pumper,
   no servidor — esta pagina so mostra. Os degraus vem do #ch-cfg.
   =========================================================================== */
(function () {
  'use strict';

  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var REDUZ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var RTL = D.documentElement.dir === 'rtl';

  /* ---------- dados ------------------------------------------------------ */
  function readJSON(id, fallback) {
    var el = D.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { console.error('[catharine-hill] JSON invalido em #' + id, e); return fallback; }
  }
  var CFG = readJSON('ch-cfg', {});
  var RAW = readJSON('ch-data', []);
  var ISO = CFG.iso || D.documentElement.lang || 'en';
  var PACK = readJSON('ch-i18n', {});
  function t(k) { return PACK[k] || ''; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fmtNum(n) {
    try { return new Intl.NumberFormat(ISO + '-u-nu-latn').format(n); } catch (e) { return String(n); }
  }

  /* ---------- familias = o menu "Maquiagem Social" do site oficial ----------
     Pelo handle (em ingles, nao muda com o idioma) e pelas tags do cadastro.
     A ORDEM importa: "cream-contour-stick" e contorno (nao skincare),
     "angel-blush-powder-palette" e blush (nao po), "lip-liner" e labio. */
  function alvoTexto(p) { return (String(p.h) + ' ' + p.tags.join(' ')).toLowerCase(); }
  function familia(p) {
    var s = alvoTexto(p);
    if (/(^|[\s-])lip(s)?([\s-]|$)|gloss|lip liner|lip care/.test(s)) return 'lips';
    if (/blush/.test(s)) return 'blush';
    if (/highlighter|contour|sculpt|bronzer/.test(s)) return 'glow';
    if (/foundation/.test(s)) return 'bases';
    if (/concealer|corrector|camouflage/.test(s)) return 'conc';
    if (/primer|blindagem/.test(s)) return 'prep';
    if (/powder/.test(s)) return 'powder';
    if (/mascara|eyeliner|eye-liner|eyeshadow|eye shadow|brow|liner/.test(s)) return 'eyes';
    if (/aloe|cleansing|face-cream|face cream|plast|moisturizer|skin care|skincare/.test(s)) return 'skin';
    return 'other';
  }
  var ROSTO = { bases: 1, conc: 1, powder: 1, prep: 1, glow: 1, blush: 1 };
  function naColecao(p, k) {
    var h = String(p.h);
    if (k === 'chill') return /(^|-)chill(-|$)/.test(h);
    if (k === 'maria') return /maria-catarina/.test(h);
    if (k === 'self') return /self-care|melt-makeup/.test(h);
    if (k === 'angel') return (CFG.angel || []).indexOf(h) > -1 || /pri-lessa/.test(h);
    return false;
  }
  function passaFiltro(p, k) {
    if (!k || k === 'all') return true;
    if (k === 'face') return !!ROSTO[p.fam];
    if (k === 'chill' || k === 'maria' || k === 'self' || k === 'angel') return naColecao(p, k);
    /* necessidades (v2): listas por handle no #ch-cfg — nao mudam com o idioma */
    if (CFG.needs && CFG.needs[k]) return CFG.needs[k].indexOf(p.h) > -1;
    return p.fam === k;
  }

  /* O Liquid devolve numero como texto em varios campos. Converte UMA vez. */
  function normVar(v) {
    v.pr = Number(v.pr) || 0;
    v.prf = String(v.prf == null ? '' : v.prf);
    v.cmpf = v.cmpf ? String(v.cmpf) : null;
    v.av = v.av === true || v.av === 'true';
    v.t = String(v.t == null ? '' : v.t);
    v.im = v.im ? String(v.im) : null;
    return v;
  }
  function prepara(lista) {
    return (lista || []).filter(function (p) { return p && p.h && p.v && p.v.length; }).map(function (p) {
      p.v = p.v.map(normVar);
      p.img = Array.isArray(p.img) ? p.img.filter(function (i) { return i && i.s; }) : [];
      p.tags = Array.isArray(p.tags) ? p.tags : [];
      p.rr = p.rr == null ? null : parseFloat(p.rr);
      if (!isFinite(p.rr)) p.rr = null;
      p.rc = Math.round(parseFloat(p.rc) || 0);
      p.av = p.v.some(function (v) { return v.av; });
      var disp = p.v.filter(function (v) { return v.av; });
      var base = (disp.length ? disp : p.v).slice().sort(function (a, b) { return a.pr - b.pr; });
      p.min = base[0];
      /* "a partir de" so quando os precos REALMENTE diferem */
      p.faixa = p.v.length > 1 && p.v.some(function (v) { return v.pr !== p.v[0].pr; });
      p.multi = p.v.length > 1;
      p.fam = familia(p);
      /* selo "Novo!" SO nos lancamentos que a marca anuncia (lista do #ch-cfg), nunca pela data de cadastro na MKPBR */
      p.isNew = (CFG.newFlag || []).indexOf(p.h) > -1;
      return p;
    });
  }
  var PRODUCTS = prepara(RAW);
  function porHandle(h) {
    for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].h === h) return PRODUCTS[i];
    return null;
  }

  /* ---------- dinheiro ---------------------------------------------------
     Cards e ficha usam v.prf, que o Liquid ja formatou. No carrinho, o
     #ch-cfg traz 12345,67 formatado pela loja: daqui sai o simbolo, a posicao
     e os separadores — o carrinho fica igual aos cards. */
  var CURRENCY = CFG.cur || 'USD';
  var MF = (function (tpl) {
    var m = /\d[\d.,'\s  ]*\d/.exec(String(tpl || ''));
    if (!m) return null;
    var num = m[0], dec = /([.,])\d{2}$/.exec(num), mil = /^12(\D+)34/.exec(num);
    return { pre: tpl.slice(0, m.index), pos: tpl.slice(m.index + num.length), dec: dec ? dec[1] : '', sep: mil ? mil[1] : '' };
  })(CFG.mfmt);
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    if (MF && CURRENCY === CFG.cur) {
      var casas = MF.dec ? 2 : 0, fix = n.toFixed(casas).split('.');
      var inteiro = fix[0].replace(/\B(?=(\d{3})+(?!\d))/g, MF.sep);
      return MF.pre + inteiro + (casas ? MF.dec + fix[1] : '') + MF.pos;
    }
    try { return new Intl.NumberFormat(ISO, { style: 'currency', currency: CURRENCY }).format(n); }
    catch (e) { return CURRENCY + ' ' + n.toFixed(2); }
  }
  function parseMoney(s) {
    var n = String(s == null ? '' : s).replace(/[^\d.,]/g, '');
    if (!n) return NaN;
    var dec = /[.,](\d{1,2})$/.exec(n);
    if (dec) return parseFloat(n.slice(0, n.length - dec[0].length).replace(/[.,]/g, '') + '.' + dec[1]);
    return parseFloat(n.replace(/[.,]/g, ''));
  }

  /* ---------- nome no card -----------------------------------------------------
     No site oficial o card mostra o nome inteiro. O titulo da MKPBR comeca com
     "Catharine Hill" e termina com o tamanho ("1.01 fl oz (30ml)"): no card
     sai a marca do comeco e o tamanho do fim; a ficha mostra o titulo inteiro. */
  function nomeCard(p) {
    var s = String(p.t || '');
    s = s.replace(/^\s*catharine\s+hill\s*[:\-–—]?\s*/i, '');
    s = s.replace(/\s*[\-–—,]?\s*\(?\d+(?:[.,]\d+)?\s*(?:fl\.?\s*oz|oz|ml|g)\b.*$/i, '');
    s = s.replace(/\s*[\-–—:,]\s*$/, '');
    return s.length >= 6 ? s : String(p.t || '');
  }
  function nomeLinha(it) {
    var p = porHandle(it.handle);
    return p ? nomeCard(p) : (it.product_title || it.title);
  }

  /* ---------- imagens com srcset -------------------------------------------- */
  function imgW(src, w) {
    if (!src) return '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function srcset(src) { return [300, 450, 600].map(function (w) { return imgW(src, w) + ' ' + w + 'w'; }).join(', '); }

  /* ---------- selo da Entrega Garantida --------------------------------------
     Abaixo de ~20px a arte oficial (que tem texto) vira borrao: no micro-selo
     do card entra o escudo em SVG. */
  var ESCUDO = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 2.6 4.6 5.4v6c0 4.4 3.1 8.5 7.4 9.9 4.3-1.4 7.4-5.5 7.4-9.9v-6L12 2.6Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M8.6 12.1l2.3 2.3 4.5-4.6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SELO = CFG.seloUrl ? '<img class="ch-selo-img" src="' + esc(CFG.seloUrl) + '" alt="" width="120" height="126" loading="lazy">' : ESCUDO;

  /* ---------- cards ---------------------------------------------------------- */
  function desconto(v) {
    if (!v || !v.cmpf) return null;
    var de = parseMoney(v.cmpf), por = parseMoney(v.prf);
    if (!isFinite(de) || !isFinite(por) || de <= por) return null;
    return { pct: Math.round((1 - por / de) * 100) };
  }
  function precoHTML(p, v) {
    v = v || p.min;
    var corpo = (v.cmpf ? '<s>' + esc(v.cmpf) + '</s>' : '') + '<b>' + esc(v.prf) + '</b>';
    return (p.faixa && v === p.min ? '<span class="ch-card__from">' + esc(t('from')) + '</span>' : '') + corpo;
  }
  function badgesHTML(p, v) {
    var d = desconto(v || p.min), out = '';
    if (p.isNew) out += '<span class="ch-b ch-b--new">' + esc(t('novo')) + '</span>';
    if (d && d.pct >= 5) out += '<span class="ch-b ch-b--promo">' + esc(t('promo')) + '</span><span class="ch-b">' + d.pct + '% ' + esc(t('off')) + '</span>';
    return out;
  }
  /* Estrelas SO quando o produto tem nota cadastrada (metafield de reviews). Nada de nota inventada. */
  function starsHTML(p) {
    if (!p.rr || !p.rc) return '';
    var cheias = Math.round(p.rr);
    return '<div class="ch-stars" aria-label="' + esc(p.rr.toFixed(1) + ' / 5') + '"><i aria-hidden="true">' +
      '★★★★★'.slice(0, cheias) + '☆☆☆☆☆'.slice(0, 5 - cheias) + '</i>(' + fmtNum(p.rc) + ')</div>';
  }
  function imgHTML(p) {
    var img = p.img[0] || {};
    var d = desconto(p.min);
    return '<div class="ch-card__img">' +
      (img.s ? '<img src="' + esc(imgW(img.s, 450)) + '" srcset="' + esc(srcset(img.s)) + '" sizes="(max-width:767px) 46vw, 283px"' +
        ' alt="' + esc(img.a || p.t) + '" loading="lazy" decoding="async" width="600" height="600">' : '') +
      img2HTML(p) +
      (p.isNew && p.av ? '<span class="ch-card__new">' + esc(t('novo')) + '</span>' : '') +
      (!p.av ? '<span class="ch-card__flag">' + esc(t('soldout')) + '</span>' : (d && d.pct >= 5 ? '<span class="ch-card__off">' + d.pct + '% ' + esc(t('off')) + '</span>' : '')) +
    '</div>';
  }
  /* O card NAO pode ser um <button> (botao dentro de botao e HTML invalido):
     div com role=button, e o clique no botao de comprar e tratado ANTES. */
  function cardEl(p) {
    var el = D.createElement('div');
    el.className = 'ch-card' + (p.av ? '' : ' ch-card--out');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', p.t);
    el.dataset.chHandle = p.h;
    var rotulo = !p.av ? t('soldout') : (p.multi ? t('choose') : t('add'));
    var attr = p.multi ? ' data-ch-open-handle="' + esc(p.h) + '"' : ' data-ch-add="' + p.min.id + '"';
    el.innerHTML = imgHTML(p) +
      '<div class="ch-card__body">' +
        '<h3>' + esc(nomeCard(p)) + '</h3>' + tonsCardHTML(p) + starsHTML(p) +
        '<div class="ch-card__price">' + precoHTML(p) + '</div>' +
        /* no lugar das parcelas do site: o micro-selo da Entrega Garantida */
        '<span class="ch-card__del">' + ESCUDO + esc(t('del_card')) + '</span>' +
        '<button type="button" class="ch-card__add"' + attr + (p.av ? '' : ' disabled') + ' aria-label="' + esc(rotulo + ' — ' + nomeCard(p)) + '">' + esc(rotulo) + '</button>' +
      '</div>';
    return el;
  }
  function pinta(grid, lista) {
    if (!grid) return;
    grid.innerHTML = '';
    grid.setAttribute('aria-busy', 'false');
    var frag = D.createDocumentFragment();
    lista.forEach(function (p) { frag.appendChild(cardEl(p)); });
    grid.appendChild(frag);
  }
  /* disponivel antes de esgotado; dentro disso, a ordem da lista */
  function dispPrimeiro(lista) {
    return lista.map(function (p, i) { return { p: p, i: i }; })
      .sort(function (a, b) { return (a.p.av === b.p.av) ? a.i - b.i : (a.p.av ? -1 : 1); })
      .map(function (x) { return x.p; });
  }
  function daLista(handles) { return (handles || []).map(porHandle).filter(Boolean); }
  var ORDEM_FAM = ['bases', 'conc', 'powder', 'prep', 'glow', 'blush', 'eyes', 'lips', 'skin', 'other'];
  function todosEmOrdem() {
    var destaque = daLista(CFG.best).concat(daLista(CFG.new));
    return dispPrimeiro(PRODUCTS.slice().sort(function (a, b) {
      var fa = ORDEM_FAM.indexOf(a.fam), fb = ORDEM_FAM.indexOf(b.fam);
      if (fa !== fb) return fa - fb;
      var da = destaque.indexOf(a), db = destaque.indexOf(b);
      if (da < 0) da = 999; if (db < 0) db = 999;
      return da - db;
    }));
  }

  /* ---------- vitrine completa: abas pelas categorias do site ------------------ */
  var FILTRO = 'all';
  function listaFiltro(k) { return todosEmOrdem().filter(function (p) { return passaFiltro(p, k); }); }
  function pintaAbas() {
    $$('[data-ch-tab]').forEach(function (b) {
      var k = b.dataset.chTab;
      var extra = /^(face|self|chill|maria|angel|wp|cov|matte|lum|multi)$/.test(k);
      var n = listaFiltro(k).length;
      /* aba de categoria sem produto neste mercado some; as "extras" so aparecem escolhidas */
      b.hidden = extra ? (k !== FILTRO || !n) : (k !== 'all' && !n);
      var on = k === FILTRO;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', String(on));
      b.tabIndex = on ? 0 : -1;
    });
    var lista = listaFiltro(FILTRO);
    pinta($('[data-ch-grid="all"]'), lista);
    var n = $('[data-ch-shop-n]');
    if (n) n.textContent = lista.length ? t('shop_n').replace('{n}', fmtNum(lista.length)) : '';
    contaNeeds();
  }
  function setFiltro(k) {
    if (!listaFiltro(k).length) k = 'all';
    FILTRO = k;
    pintaAbas();
  }
  function ligaAbas() {
    var abas = $$('[data-ch-tab]');
    abas.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); setFiltro(b.dataset.chTab); });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var vis = abas.filter(function (x) { return !x.hidden; });
        var i = vis.indexOf(b);
        var passo = (e.key === 'ArrowRight' ? 1 : -1) * (RTL ? -1 : 1);
        var alvo = vis[(i + passo + vis.length) % vis.length];
        if (alvo) { e.preventDefault(); setFiltro(alvo.dataset.chTab); var nb = $('[data-ch-tab="' + FILTRO + '"]'); if (nb) nb.focus(); }
      });
    });
  }

  /* ---------- carrossel de cards: scroll NATIVO; setas e tracos acompanham ---------- */
  function atualizaRail(rail) {
    if (!rail) return;
    var track = $('.ch-rail__track', rail);
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var x = Math.abs(track.scrollLeft); /* em RTL o Chrome devolve scrollLeft negativo */
    var sobra = max > 4;
    var prev = $('[data-ch-rail-prev]', rail), next = $('[data-ch-rail-next]', rail);
    if (prev) { prev.disabled = !sobra || x < 8; prev.hidden = !sobra; }
    if (next) { next.disabled = !sobra || x > max - 8; next.hidden = !sobra; }
    var dots = $('[data-ch-rail-dots]', rail);
    if (dots) {
      var n = sobra ? Math.ceil((track.scrollWidth - 4) / track.clientWidth) : 0;
      if (dots.childElementCount !== n) {
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = D.createElement('button');
          b.type = 'button'; b.className = 'ch-dot'; b.dataset.chRailGo = String(i);
          b.setAttribute('aria-label', t('slide') + ' ' + (i + 1));
          dots.appendChild(b);
        }
      }
      var atual = max > 0 ? Math.round((x / max) * (n - 1)) : 0;
      $$('.ch-dot', dots).forEach(function (d, i) { d.classList.toggle('is-on', i === atual); });
    }
  }
  function ligaRail(rail) {
    if (!rail) return;
    var track = $('.ch-rail__track', rail);
    if (!track) return;
    if (!rail.dataset.pronto) {
      rail.dataset.pronto = '1';
      var raf = 0;
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; atualizaRail(rail); }); }, { passive: true });
      track.addEventListener('load', function () { atualizaRail(rail); }, true);
      $$('[data-ch-rail-prev],[data-ch-rail-next]', rail).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var dir = b.hasAttribute('data-ch-rail-next') ? 1 : -1;
          if (RTL) dir = -dir;
          track.scrollBy({ left: dir * track.clientWidth, behavior: REDUZ ? 'auto' : 'smooth' });
        });
      });
      rail.addEventListener('click', function (e) {
        var d = e.target.closest && e.target.closest('[data-ch-rail-go]');
        if (!d) return;
        e.preventDefault(); e.stopPropagation();
        var i = Number(d.dataset.chRailGo);
        var max = track.scrollWidth - track.clientWidth, n = $$('.ch-dot', rail).length;
        var alvo = n > 1 ? (i / (n - 1)) * max : 0;
        track.scrollTo({ left: RTL ? -alvo : alvo, behavior: REDUZ ? 'auto' : 'smooth' });
      });
    }
    atualizaRail(rail);
    if (window.requestAnimationFrame) requestAnimationFrame(function () { atualizaRail(rail); });
    setTimeout(function () { atualizaRail(rail); }, 500);
  }

  /* ---------- vitrines ------------------------------------------------------------ */
  function listaNovidades() { return dispPrimeiro(daLista(CFG.new)); }
  function listaQueridinhos() { return dispPrimeiro(daLista(CFG.best)); }
  function listaAngel() {
    var l = daLista(CFG.angel);
    PRODUCTS.forEach(function (p) { if (naColecao(p, 'angel') && l.indexOf(p) < 0) l.push(p); });
    return dispPrimeiro(l);
  }
  function renderGrids() {
    var vazio = !PRODUCTS.length;
    var painel = $('[data-ch-nostock]');
    if (painel) {
      if (vazio && !painel.childElementCount) { var tpl = $('[data-ch-nostock-tpl]'); if (tpl && tpl.content) painel.appendChild(tpl.content.cloneNode(true)); }
      painel.hidden = !vazio;
    }
    if (vazio) {
      $$('#ch-new .ch-shelf__head,[data-ch-rail],#ch-best,#ch-shop,[data-ch-cards],#ch-angel .ch-shelf__head,#ch-seen,#ch-tons,#ch-look').forEach(function (s) { s.hidden = true; });
      return;
    }
    [['new', listaNovidades()], ['best', listaQueridinhos()], ['angel', listaAngel()]].forEach(function (par) {
      var grid = $('[data-ch-grid="' + par[0] + '"]');
      pinta(grid, par[1]);
      var rail = $('[data-ch-rail="' + par[0] + '"]');
      if (rail) { rail.hidden = !par[1].length; var tr = $('.ch-rail__track', rail); if (tr) tr.scrollLeft = 0; ligaRail(rail); }
    });
    pintaAbas();
    montaPopulares();
    /* atalhos para produto fora do mercado viram nada (link morto nao leva a lugar nenhum) */
    $$('.ch-foot [data-ch-open-handle]').forEach(function (a) { var li = a.closest('li'); if (li) li.hidden = !porHandle(a.dataset.chOpenHandle); });
    renderV2();
  }


  /* ---------- texto por cima das artes: encolhe se a traducao nao cabe ----------
     data-ch-fit="computador|celular" = largura maxima como fracao da arte
     (0 = nao mexe). Guarda so a PROPORCAO em --fit: como tudo e medido em
     cqw, a proporcao vale para qualquer largura de tela. */
  var CEL = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  function encaixa() {
    var cel = CEL && CEL.matches;
    $$('[data-ch-fit]').forEach(function (el) {
      var par = String(el.dataset.chFit).split('|');
      var max = parseFloat(cel ? par[1] : par[0]);
      el.style.removeProperty('--fit');
      if (!max) return;
      var box = el.closest('.ch-slide__link,.ch-card3,.ch-aw');
      if (!box) return;
      var bw = box.getBoundingClientRect().width, w = el.getBoundingClientRect().width;
      if (bw && w > max * bw) el.style.setProperty('--fit', ((max * bw) / w * 0.98).toFixed(3));
    });
  }
  function ligaEncaixe() {
    encaixa();
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(encaixa);
    if (CEL) { if (CEL.addEventListener) CEL.addEventListener('change', encaixa); else if (CEL.addListener) CEL.addListener(encaixa); }
  }

  /* ==========================================================================
     BANNER — carrossel de 3 slides, com tracos (o do site oficial). Troca
     sozinho a cada 6 s (menos com o mouse em cima, com foco dentro ou com
     "reduzir movimento" ligado).
     ========================================================================== */
  var HERO = { i: 0, n: 0, t: null, dur: 6000, pausa: false };
  function heroVai(k) {
    var hero = $('[data-ch-hero]');
    if (!hero) return;
    var slides = $$('[data-ch-slide]', hero);
    HERO.n = slides.length;
    HERO.i = (k + HERO.n) % HERO.n;
    slides.forEach(function (s, i) {
      var on = i === HERO.i;
      s.classList.toggle('is-on', on);
      if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      $$('a,button', s).forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
      /* as imagens dos slides escondidos so baixam quando o slide chega perto */
      if (on) $$('img[loading="lazy"]', s).forEach(function (im) { im.loading = 'eager'; });
    });
    $$('[data-ch-hero-go]', hero).forEach(function (d, i) {
      d.classList.toggle('is-on', i === HERO.i);
      if (i === HERO.i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
    });
    heroAgenda();
  }
  function heroAgenda() {
    clearTimeout(HERO.t);
    if (REDUZ || HERO.pausa || HERO.n < 2) return;
    HERO.t = setTimeout(function () { heroVai(HERO.i + 1); }, HERO.dur);
  }
  function ligaHero() {
    var hero = $('[data-ch-hero]');
    if (!hero) return;
    var prev = $('[data-ch-hero-prev]', hero), next = $('[data-ch-hero-next]', hero);
    if (prev) prev.addEventListener('click', function () { heroVai(HERO.i - 1); });
    if (next) next.addEventListener('click', function () { heroVai(HERO.i + 1); });
    $$('[data-ch-hero-go]', hero).forEach(function (d) { d.addEventListener('click', function () { heroVai(Number(d.dataset.chHeroGo)); }); });
    var box = $('.ch-hero__in', hero) || hero;
    box.addEventListener('mouseenter', function () { HERO.pausa = true; heroAgenda(); });
    box.addEventListener('mouseleave', function () { HERO.pausa = false; heroAgenda(); });
    hero.addEventListener('focusin', function () { HERO.pausa = true; heroAgenda(); });
    hero.addEventListener('focusout', function () { HERO.pausa = false; heroAgenda(); });
    /* arrastar com o dedo */
    var x0 = null, y0 = null, arrastou = false;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; arrastou = false; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      arrastou = true;
      var ir = dx < 0 ? 1 : -1;
      if (RTL) ir = -ir;
      heroVai(HERO.i + ir);
    }, { passive: true });
    /* arrastar nao e clicar: o slide nao abre a ficha depois de um arraste */
    hero.addEventListener('click', function (e) { if (arrastou) { e.preventDefault(); e.stopPropagation(); arrastou = false; } }, true);
    D.addEventListener('visibilitychange', function () { if (D.hidden) clearTimeout(HERO.t); else heroAgenda(); });
    heroVai(0);
  }

  /* ==========================================================================
     BUSCA — inteira no navegador, sobre o JSON ja baixado (nada de /search,
     que traria outras marcas para dentro da loja da Catharine Hill).
     ========================================================================== */
  var buscaEl, buscaVeil, buscaInput, buscaRes, buscaSug, buscaNone, buscaT;
  function normal(s) {
    s = String(s == null ? '' : s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* motor antigo */ }
    return s;
  }
  function buscar(q) {
    var n = normal(q).trim();
    if (n.length < 2) return [];
    var termos = n.split(/\s+/);
    return PRODUCTS.filter(function (p) {
      /* o handle entra na busca: e em ingles e nao muda com o idioma */
      var alvo = normal(p.t) + ' ' + normal(p.h.replace(/-/g, ' ')) + ' ' + normal(p.tags.join(' ')) + ' ' +
                 normal(p.v.map(function (v) { return (v.sku || '') + ' ' + v.t; }).join(' '));
      return termos.every(function (x) { return alvo.indexOf(x) > -1; });
    }).slice(0, 40);
  }
  function sresHTML(p) {
    var img = (p.img[0] || {}).s || '';
    return '<button type="button" class="ch-sres" data-ch-open-handle="' + esc(p.h) + '">' +
      '<span class="ch-sres__img">' + (img ? '<img src="' + esc(imgW(img, 120)) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span><b>' + esc(nomeCard(p)) + '</b><span>' + precoHTML(p).replace(/<\/?b>/g, '') + '</span></span></button>';
  }
  function montaPopulares() {
    var alvo = $('[data-ch-search-popular]');
    if (!alvo) return;
    alvo.innerHTML = daLista(CFG.best).filter(function (p) { return p.av; }).slice(0, 5).map(sresHTML).join('');
  }
  function pintaResultados(q) {
    if (!buscaRes) return;
    var lista = buscar(q);
    var temTermo = normal(q).trim().length >= 2;
    if (buscaSug) buscaSug.hidden = temTermo;
    buscaRes.hidden = !temTermo;
    if (buscaNone) buscaNone.hidden = !(temTermo && !lista.length);
    buscaRes.innerHTML = lista.map(sresHTML).join('');
  }
  function abrirBusca(termo) {
    if (!buscaEl) return;
    fecharMenu();
    if (termo != null && buscaInput) { buscaInput.value = termo; pintaResultados(termo); }
    if (buscaEl.classList.contains('is-on')) return;
    lastFocus = D.activeElement;
    buscaEl.classList.add('is-on');
    buscaEl.setAttribute('aria-hidden', 'false');
    if (buscaVeil) { buscaVeil.hidden = false; requestAnimationFrame(function () { buscaVeil.classList.add('is-on'); }); }
    travarRolagem();
    if (buscaInput) setTimeout(function () { buscaInput.focus(); }, 60);
  }
  function fecharBusca() {
    if (!buscaEl || !buscaEl.classList.contains('is-on')) return;
    buscaEl.classList.remove('is-on');
    buscaEl.setAttribute('aria-hidden', 'true');
    if (buscaVeil) { buscaVeil.classList.remove('is-on'); setTimeout(function () { buscaVeil.hidden = true; }, 220); }
    destravarRolagem();
  }
  function ligaBusca() {
    buscaEl = $('[data-ch-search]');
    buscaVeil = $('[data-ch-search-veil]');
    buscaInput = $('[data-ch-search-input]');
    buscaRes = $('[data-ch-search-results]');
    buscaSug = $('[data-ch-search-suggest]');
    buscaNone = $('[data-ch-search-none]');
    if (!buscaEl || !buscaInput) return;
    buscaInput.addEventListener('input', function () {
      clearTimeout(buscaT);
      var v = buscaInput.value;
      buscaT = setTimeout(function () { pintaResultados(v); }, 120);
    });
    buscaInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(buscaT); pintaResultados(buscaInput.value); }
    });
  }

  /* ---------- menu "Produtos" (painel lateral) ---------------------------------------- */
  var menuEl, menuVeil;
  function abrirMenu() {
    if (!menuEl || menuEl.classList.contains('is-on')) return;
    lastFocus = D.activeElement;
    menuEl.classList.add('is-on');
    menuEl.setAttribute('aria-hidden', 'false');
    if (menuVeil) { menuVeil.hidden = false; requestAnimationFrame(function () { menuVeil.classList.add('is-on'); }); }
    travarRolagem();
    var x = $('[data-ch-menu-close]', menuEl);
    if (x) x.focus();
  }
  function fecharMenu() {
    if (!menuEl || !menuEl.classList.contains('is-on')) return;
    menuEl.classList.remove('is-on');
    menuEl.setAttribute('aria-hidden', 'true');
    if (menuVeil) { menuVeil.classList.remove('is-on'); setTimeout(function () { menuVeil.hidden = true; }, 220); }
    destravarRolagem();
  }

  /* ---------- cabecalho: gruda no topo; o logo encolhe --------------------------------- */
  function ligaCabecalho() {
    var head = $('[data-ch-head]'), top = $('.ch-top');
    if (!head) return;
    var pedido = false;
    function mede() {
      var lim = top ? top.getBoundingClientRect().height : 40;
      head.classList.toggle('is-stuck', window.scrollY > lim + 4);
    }
    window.addEventListener('scroll', function () {
      if (pedido) return;
      pedido = true;
      requestAnimationFrame(function () { pedido = false; mede(); });
    }, { passive: true });
    mede();
  }

  /* ---------- paginas 2..N ----------------------------------------------------------
     Pelo ?view=catharine-hill-data, que devolve SO o JSON. Tres tentativas com
     pausa crescente: um 502 do proprio Shopify ja tirou metade da vitrine da Prohall. */
  function buscaPagina(n, tentativa) {
    var url = (CFG.root || '') + '/pages/catharine-hill?view=catharine-hill-data&page=' + n;
    /* SEM "Accept: application/json": com esse cabecalho a Shopify ignora o
       ?view= e devolve o JSON nativo da pagina (medido na Gold Spell). */
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) {
        var j = JSON.parse(txt);
        if (!j || !j.products || !j.products.length) throw new Error('pagina vazia');
        return j.products;
      })
      .catch(function (err) {
        if (tentativa >= 3) { console.warn('[catharine-hill] pagina ' + n + ' nao veio:', err.message); return []; }
        return new Promise(function (ok) { setTimeout(ok, 400 * tentativa); }).then(function () { return buscaPagina(n, tentativa + 1); });
      });
  }
  function carregarResto() {
    var total = Number(CFG.pages) || 1;
    if (total < 2 || !PRODUCTS.length) return Promise.resolve();
    var pedidos = [];
    for (var n = 2; n <= total; n++) pedidos.push(buscaPagina(n, 1));
    return Promise.all(pedidos).then(function (partes) {
      var vistos = {};
      PRODUCTS.forEach(function (p) { vistos[p.h] = true; });
      var novos = [];
      partes.forEach(function (lista) { lista.forEach(function (p) { if (p && p.h && !vistos[p.h]) { vistos[p.h] = true; novos.push(p); } }); });
      if (!novos.length) return;
      PRODUCTS = PRODUCTS.concat(prepara(novos));
      renderGrids();
    });
  }

  /* ---------- trava de rolagem ---------------------------------------------------------
     Trava o HTML e o body: com html{overflow-x:clip}, travar so o body deixava
     a roda do mouse rolar a LP por tras do popup (armadilha da Peach Up). */
  var travas = 0;
  function travarRolagem() { travas++; D.documentElement.classList.add('ch-lock'); D.body.classList.add('ch-lock'); }
  function destravarRolagem() {
    travas = Math.max(0, travas - 1);
    if (!travas) { D.documentElement.classList.remove('ch-lock'); D.body.classList.remove('ch-lock'); }
  }

  /* ---------- ficha do produto ---------------------------------------------------------- */
  var pdpOvl, pdpBox, lastFocus = null;
  var PDP = { p: null, v: null };
  var INFO = {};

  function linhas(txt) { return String(txt || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean); }
  function bulletsHTML(txt) {
    var ls = linhas(txt);
    if (!ls.length) return '';
    return ls.length > 1 ? '<ul>' + ls.map(function (l) { return '<li>' + esc(l.replace(/^[-•]\s*/, '')) + '</li>'; }).join('') + '</ul>' : '<p>' + esc(ls[0]) + '</p>';
  }
  function parasHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n{2,}|\n---\n/).map(function (b) {
      var l = b.trim();
      return l ? '<p>' + esc(l).replace(/\n/g, '<br>') + '</p>' : '';
    }).join('');
  }
  /* "Ingredientes explicados": blocos separados por ---, NOME na primeira
     linha; linha comecando com ⚠ e aviso e ganha destaque proprio. */
  function ingHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n?---\n?/).map(function (bloco) {
      var ls = linhas(bloco);
      if (!ls.length) return '';
      var nome = ls.shift();
      var aviso = ls.filter(function (x) { return /^⚠/.test(x); });
      var corpo = ls.filter(function (x) { return !/^⚠/.test(x); });
      return '<div class="ch-ing"><strong>' + esc(nome) + '</strong>' + esc(corpo.join(' ')) +
        (aviso.length ? '<span class="ch-warn">' + esc(aviso.join(' ')) + '</span>' : '') + '</div>';
    }).join('');
  }
  function acc(key, body, open) {
    if (!body) return '';
    return '<details class="ch-acc"' + (open ? ' open' : '') + '><summary>' + esc(t(key)) + '</summary><div class="ch-acc__c">' + body + '</div></details>';
  }
  function degrauDe(total) {
    var at = null;
    (CFG.steps || []).forEach(function (s) { if (total >= s.q) at = s; });
    return at;
  }
  function qdHTML() {
    var passos = CFG.steps || [];
    if (!passos.length) return '';
    return '<div class="ch-pdp__qd" data-ch-pdp-qd><strong>' + esc(t('qd_t')) + '</strong><ul>' +
      passos.map(function (s) {
        return '<li data-q="' + s.q + '"><b>' + s.p + '%</b><span>' + esc(s.q >= 4 ? t('qd_4') : t('qd_' + s.q)) + '</span></li>';
      }).join('') + '</ul><small>' + esc(t('qd_d')) + ' ' + esc(t('qd_note')) + '</small></div>';
  }
  /* Variantes = tons da marca. Quando a variante tem foto propria, a bolinha
     mostra a foto (o tom de verdade), e escolher o tom troca a foto grande. */
  function optHTML(p) {
    if (!p.multi) return '';
    var rotulo = p.opt && p.opt !== 'Title' ? p.opt : t('pdp_opt');
    return '<div class="ch-opt"><span class="ch-opt__l" id="ch-opt-l">' + esc(rotulo) + '</span>' +
      '<div class="ch-opt__list" role="group" aria-labelledby="ch-opt-l">' +
      p.v.map(function (v) {
        return '<button type="button" class="ch-opt__b" data-ch-var="' + v.id + '" aria-pressed="' + (PDP.v && PDP.v.id === v.id) + '"' +
          (v.av ? '' : ' disabled') + '>' + (v.im ? '<img src="' + esc(imgW(v.im, 80)) + '" alt="" loading="lazy">' : '') + esc(v.t) + '</button>';
      }).join('') + '</div></div>';
  }
  function pintarVariante(trocaFoto) {
    var p = PDP.p, v = PDP.v;
    if (!p || !v) return;
    var preco = $('[data-ch-pdp-price]');
    if (preco) preco.innerHTML = (v.cmpf ? '<s>' + esc(v.cmpf) + '</s>' : '') + '<b>' + esc(v.prf) + '</b>';
    var bdg = $('[data-ch-pdp-badges]');
    if (bdg) bdg.innerHTML = badgesHTML(p, v);
    var sku = $('[data-ch-pdp-sku]');
    if (sku) { sku.textContent = t('pdp_sku') + ': ' + (v.sku || '—'); sku.hidden = !v.sku; }
    $$('[data-ch-var]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.chVar) === Number(v.id))); });
    $$('[data-ch-add],[data-ch-buy]', pdpBox).forEach(function (b) {
      var ehAdd = b.hasAttribute('data-ch-add');
      if (ehAdd) b.dataset.chAdd = v.id; else b.dataset.chBuy = v.id;
      b.disabled = !v.av;
      b.textContent = v.av ? (ehAdd ? t('add') : t('buy')) : t('soldout');
    });
    if (trocaFoto && v.im) {
      var main = $('[data-ch-main]');
      if (main) { main.src = imgW(v.im, 900); main.alt = p.t + ' — ' + v.t; }
      $$('[data-ch-th]').forEach(function (b) { b.removeAttribute('aria-current'); });
    }
    var qty = $('.ch-pdp__qty');
    if (qty) qty.hidden = !v.av;
    marcarDegrausPDP();
  }

  var PDP_QTD_MAX = 10;
  function qtdHTML() {
    return '<div class="ch-pdp__qty"><span class="ch-pdp__qty-l" id="ch-pdp-qty-l">' + esc(t('pdp_qty')) + '</span>' +
      '<span class="ch-step ch-step--lg" role="group" aria-labelledby="ch-pdp-qty-l">' +
      '<button type="button" data-ch-pdp-step="-1" aria-label="' + esc(t('c_less')) + '" disabled>&minus;</button>' +
      '<span data-ch-pdp-qtd aria-live="polite">1</span>' +
      '<button type="button" data-ch-pdp-step="1" aria-label="' + esc(t('c_more')) + '">+</button></span></div>';
  }
  function pdpQtd() {
    var el = $('[data-ch-pdp-qtd]');
    var n = el ? parseInt(el.textContent, 10) : 1;
    return (isFinite(n) && n > 0) ? Math.min(PDP_QTD_MAX, n) : 1;
  }
  function porQtdPDP(n) {
    var el = $('[data-ch-pdp-qtd]');
    if (!el) return;
    n = Math.min(PDP_QTD_MAX, Math.max(1, n));
    el.textContent = String(n);
    var menos = $('[data-ch-pdp-step="-1"]'), mais = $('[data-ch-pdp-step="1"]');
    if (menos) menos.disabled = n <= 1;
    if (mais) mais.disabled = n >= PDP_QTD_MAX;
    marcarDegrausPDP();
  }
  /* O Pumper conta o carrinho INTEIRO: acende o degrau do que o carrinho VAI
     ter depois de somar a quantidade escolhida aqui. */
  function marcarDegrausPDP() {
    var caixa = $('[data-ch-pdp-qd]');
    if (!caixa) return;
    var at = degrauDe(CART.count + pdpQtd());
    $$('li', caixa).forEach(function (li) { li.classList.toggle('is-on', !!at && Number(li.dataset.q) === at.q); });
  }
  /* O que abre o popup da garantia, de qualquer lugar: <label for>, nunca um
     link para outra guia (quem sai da LP perde o carrinho de vista). */
  function abreGarantia(rotulo) {
    return '<label class="ch-lnk" for="ch-guar-cbx" role="button" tabindex="0">' + esc(t(rotulo)) + '</label>';
  }
  function entregaHTML() {
    return '<div class="ch-pdp__del">' + SELO + '<div><b>' + esc(t('del_t')) + '</b><p>' + esc(t('del_pdp')) + '</p>' + abreGarantia('del_c') + '</div></div>';
  }
  /* A parte pesada da ficha: descricao completa + resumo por IA, pelo
     ?view=catharine-hill-info. Se falhar, cai para o /products/<h>.js. */
  function carregaInfo(h) {
    if (INFO[h]) return Promise.resolve(INFO[h]);
    var base = (CFG.root || '') + '/products/' + encodeURIComponent(h);
    return fetch(base + '?view=catharine-hill-info', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) { return JSON.parse(txt); })
      .catch(function () {
        return fetch(base + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) { return { ai: {}, d: j.description || '' }; });
      })
      .then(function (info) { INFO[h] = info || { ai: {}, d: '' }; return INFO[h]; })
      .catch(function () { return { ai: {}, d: '' }; });
  }
  function pintaInfo(p, info) {
    var alvo = $('[data-ch-pdp-more]');
    if (!alvo || !PDP.p || PDP.p.h !== p.h) return;
    var ai = info.ai || {};
    var tag = $('[data-ch-pdp-tag]');
    if (tag) { tag.textContent = ai.tag || ''; tag.hidden = !ai.tag; }
    alvo.innerHTML =
      acc('pdp_purpose', bulletsHTML(ai.pur), true) +
      acc('pdp_high', bulletsHTML(ai.hig)) +
      acc('pdp_how', parasHTML(ai.how)) +
      acc('pdp_audience', parasHTML(ai.aud)) +
      acc('pdp_good', bulletsHTML(ai.gtk)) +
      acc('pdp_ing', ingHTML(ai.ing)) +
      acc('pdp_tog', parasHTML(ai.tog)) +
      (info.d ? '<details class="ch-acc"' + (ai.pur ? '' : ' open') + '><summary>' + esc(t('pdp_desc')) + '</summary><div class="ch-acc__c ch-desc">' + info.d + '</div></details>' : '') +
      (info.note ? '<p class="ch-legal">' + esc(info.note) + '</p>' : '');
  }
  function openPDP(handle, vid) {
    var p = porHandle(handle);
    if (!p || !pdpOvl) return false;
    fecharMenu();
    fecharPost(true);
    if (!pdpOvl.classList.contains('is-on')) lastFocus = D.activeElement;
    PDP.p = p;
    PDP.v = p.min; /* abre na variante disponivel mais barata, nunca numa esgotada */
    var thumbs = p.img.map(function (im, i) {
      return '<button type="button" data-ch-th="' + i + '"' + (i === 0 ? ' aria-current="true"' : '') + ' aria-label="' + (i + 1) + '/' + p.img.length + '">' +
        '<img src="' + esc(imgW(im.s, 120)) + '" alt="" loading="lazy"></button>';
    }).join('');
    var im0 = p.img[0] || {};
    pdpBox.innerHTML =
      '<button type="button" class="ch-x" data-ch-pdp-close aria-label="' + esc(t('pdp_close')) + '">&times;</button>' +
      '<div class="ch-pdp">' +
        '<div class="ch-pdp__gal">' +
          '<div class="ch-pdp__main">' + (im0.s ? '<img src="' + esc(imgW(im0.s, 900)) + '" alt="' + esc(im0.a || p.t) + '" width="900" height="900" data-ch-main>' : '') + '</div>' +
          (p.img.length > 1 ? '<div class="ch-pdp__thumbs">' + thumbs + '</div>' : '') +
        '</div>' +
        '<div class="ch-pdp__info">' +
          '<p class="ch-pdp__brand">Catharine Hill · ' + esc(t('official')) + '</p>' +
          '<h2 id="ch-pdp-t">' + esc(p.t) + '</h2>' +
          starsHTML(p) +
          '<p class="ch-pdp__tag" data-ch-pdp-tag hidden></p>' +
          '<div class="ch-pdp__badges" data-ch-pdp-badges></div>' +
          '<div class="ch-pdp__price" data-ch-pdp-price></div>' +
          optHTML(p) + qtdHTML() + qdHTML() +
          '<div class="ch-pdp__acts">' +
            '<button type="button" class="ch-btn ch-btn--ghost" data-ch-add=""></button>' +
            '<button type="button" class="ch-btn" data-ch-buy=""></button>' +
          '</div>' +
          entregaHTML() +
          '<div data-ch-pdp-more><div class="ch-skel" aria-hidden="true"><i></i><i></i><i></i></div></div>' +
          '<p class="ch-nota" style="margin:0" data-ch-pdp-sku></p>' +
        '</div>' +
      '</div>';
    if (!pdpOvl.classList.contains('is-on')) { pdpOvl.classList.add('is-on'); travarRolagem(); }
    pdpOvl.scrollTop = 0; pdpBox.scrollTop = 0;
    porQtdPDP(1);
    var pedida = vid ? p.v.filter(function (v) { return String(v.id) === String(vid); })[0] : null;
    if (pedida) PDP.v = pedida;
    pintarVariante(!!pedida);
    var x = $('[data-ch-pdp-close]', pdpBox);
    if (x) x.focus();
    carregaInfo(p.h).then(function (info) { pintaInfo(p, info); });
    return true;
  }
  function closePDP() {
    if (!pdpOvl || !pdpOvl.classList.contains('is-on')) return;
    pdpOvl.classList.remove('is-on');
    destravarRolagem();
    pdpBox.innerHTML = '';
    PDP.p = null; PDP.v = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- post do blog (abre aqui, numa janela) ---------------------------------------- */
  var postOvl, postBox;
  function miniHTML(p) {
    var img = (p.img[0] || {}).s || '';
    return '<li><button type="button" class="ch-mini" data-ch-open-handle="' + esc(p.h) + '">' +
      '<span>' + (img ? '<img src="' + esc(imgW(img, 300)) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<b>' + esc(nomeCard(p)) + '</b><i>' + precoHTML(p).replace(/<\/?b>/g, '').replace(/<span[^>]*>.*?<\/span>/, '') + '</i></button></li>';
  }
  function abrirPost(i) {
    var tpl = $('[data-ch-post-tpl="' + i + '"]');
    if (!tpl || !postOvl || !postBox) return;
    if (!postOvl.classList.contains('is-on')) lastFocus = D.activeElement;
    postBox.innerHTML = '<button type="button" class="ch-x" data-ch-post-close aria-label="' + esc(t('pdp_close')) + '">&times;</button><div class="ch-post__box"></div>';
    var box = $('.ch-post__box', postBox);
    box.appendChild(tpl.content.cloneNode(true));
    var prods = $('[data-ch-post-prods]', box);
    if (prods) {
      var lista = String(prods.dataset.chPostProds || '').split(/\s+/).map(porHandle).filter(Boolean);
      prods.innerHTML = lista.length ? '<h3>' + esc(t('blog_prods')) + '</h3><ul>' + lista.map(miniHTML).join('') + '</ul>' : '';
    }
    if (!postOvl.classList.contains('is-on')) { postOvl.classList.add('is-on'); travarRolagem(); }
    postOvl.scrollTop = 0; postBox.scrollTop = 0;
    var x = $('[data-ch-post-close]', postBox);
    if (x) x.focus();
  }
  function fecharPost(semFoco) {
    if (!postOvl || !postOvl.classList.contains('is-on')) return;
    postOvl.classList.remove('is-on');
    destravarRolagem();
    postBox.innerHTML = '';
    if (!semFoco && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- carrinho ------------------------------------------------------------------- */
  var CART = { items: [], total: 0, count: Number((CFG.cart || {}).count) || 0, raw: null };
  var cartEl, veilEl, bodyEl, footEl, totalEl, countEl, qdEl, shipEl;

  /* Recado de frete CALCULADO por window.MKPBR_SHIP (a mesma conta da barra
     da loja) e escrito dentro do carrinho. */
  function espelharFrete() {
    if (!shipEl) return;
    var S = window.MKPBR_SHIP;
    if (!S || typeof S.compute !== 'function' || !CART.raw || CART.count < 1) { shipEl.hidden = true; return; }
    var e;
    try { e = S.compute(CART.raw); } catch (err) { console.error('[catharine-hill] frete', err); shipEl.hidden = true; return; }
    if (!e) { shipEl.hidden = true; return; }
    if (e.freeReached) shipEl.innerHTML = '<b>' + esc(t('ship_free')) + '</b>';
    else if (e.faltaProximo > 0 && e.economiaProximo > 0) {
      shipEl.innerHTML = '<b>' + esc(t('ship_more').replace('{v}', money(Math.round(e.faltaProximo * 100))).replace('{p}', money(Math.round(e.economiaProximo * 100)))) + '</b>';
    } else { shipEl.hidden = true; return; }
    shipEl.hidden = false;
  }
  function cartURL(path) { return (CFG.root || '') + path; }
  function aplicarCarrinho(c) {
    if (!c) return;
    CART.items = c.items || [];
    CART.total = c.total_price || 0;
    CART.count = c.item_count || 0;
    CART.raw = c;
    if (c.currency) CURRENCY = c.currency;
    syncCart();
  }
  function fetchCart() {
    return fetch(cartURL('/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { aplicarCarrinho(c); return c; })
      .catch(function (e) { console.error('[catharine-hill] cart.js', e); });
  }
  function syncCart() {
    if (countEl) countEl.textContent = CART.count;
    /* a barra de frete da loja so aparece DEPOIS que existe carrinho */
    D.body.classList.toggle('ch-has-cart', CART.count > 0);
    renderCart();
    markStep();
    renderLook();
  }
  function renderCart() {
    if (!bodyEl) return;
    if (!CART.items.length) {
      bodyEl.innerHTML = '<div class="ch-cart__empty"><strong>' + esc(t('c_empty')) + '</strong><span>' + esc(t('c_empty_d')) + '</span>' +
        '<button type="button" class="ch-btn ch-btn--ghost ch-btn--sm" data-ch-cart-close>' + esc(t('c_empty_cta')) + '</button></div>';
      if (footEl) footEl.hidden = true;
      return;
    }
    bodyEl.innerHTML = CART.items.map(function (it) {
      var img = it.image ? imgW(it.image, 160) : '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="ch-line__v">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="ch-line" data-key="' + esc(it.key) + '">' +
        '<div class="ch-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div><span class="ch-line__t">' + esc(nomeLinha(it)) + '</span>' + vt +
          '<div class="ch-line__r"><span class="ch-step">' +
            '<button type="button" data-ch-qty="-1" aria-label="' + esc(t('c_less')) + '">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-ch-qty="1" aria-label="' + esc(t('c_more')) + '">+</button></span>' +
            '<span class="ch-line__p">' + money(it.final_line_price != null ? it.final_line_price : it.line_price) + '</span></div>' +
          '<button type="button" class="ch-line__x" data-ch-rm>' + esc(t('c_rm')) + '</button>' +
        '</div></div>';
    }).join('');
    if (footEl) footEl.hidden = false;
    if (totalEl) totalEl.textContent = money(CART.total);
  }
  function markStep() {
    var at = degrauDe(CART.count);
    marcarDegrausPDP();
    $$('[data-ch-qd] li').forEach(function (li) { li.classList.toggle('is-on', !!at && Number(li.dataset.q) === at.q); });
    if (qdEl) {
      if (at) {
        qdEl.textContent = (at.q >= 4 ? t('qd_4') : t('qd_' + at.q)) + ' · ' + at.p + '% ' + t('off') + ' — ' + t('qd_note');
        qdEl.hidden = false;
      } else qdEl.hidden = true;
    }
    espelharFrete();
  }
  function openCart() {
    if (!cartEl || cartEl.classList.contains('is-on')) return;
    fecharMenu();
    lastFocus = D.activeElement;
    cartEl.classList.add('is-on');
    cartEl.setAttribute('aria-hidden', 'false');
    if (veilEl) { veilEl.hidden = false; requestAnimationFrame(function () { veilEl.classList.add('is-on'); }); }
    travarRolagem();
    espelharFrete();
    var c = $('[data-ch-cart-close]', cartEl);
    if (c) c.focus();
  }
  function closeCart() {
    if (!cartEl || !cartEl.classList.contains('is-on')) return;
    cartEl.classList.remove('is-on');
    cartEl.setAttribute('aria-hidden', 'true');
    if (veilEl) { veilEl.classList.remove('is-on'); setTimeout(function () { veilEl.hidden = true; }, 220); }
    destravarRolagem();
    if (lastFocus && lastFocus.focus && !pdpOvl.classList.contains('is-on')) lastFocus.focus();
  }

  var toastT;
  function toast(msg) {
    var el = $('[data-ch-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }
  function addToCart(vid, abrir, btn, qtd) {
    if (!vid) return;
    var q = Math.min(PDP_QTD_MAX, Math.max(1, Number(qtd) || 1));
    var rotulo = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); btn.textContent = t('adding'); }
    return fetch(cartURL('/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: q }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        if (btn) {
          btn.disabled = false; btn.classList.remove('is-busy'); btn.classList.add('is-done'); btn.textContent = t('added');
          setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = rotulo; }, 1400);
        }
        porQtdPDP(1);
        /* card e "adicionar" NAO abrem o carrinho; "comprar agora" abre */
        if (abrir) { closePDP(); openCart(); } else toast(t('toast_added'));
      })
      .catch(function (e) {
        console.error('[catharine-hill] add', e);
        if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); btn.innerHTML = rotulo; }
        toast(t('err_add'));
      });
  }
  function changeQty(key, qty) {
    return fetch(cartURL('/cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(aplicarCarrinho)
      .catch(function (e) { console.error('[catharine-hill] change', e); });
  }

  /* ---------- seletores de pais e idioma ---------------------------------------------- */
  function bindPicker(wrap) {
    if (!wrap) return;
    var btn = $('.ch-pick__btn', wrap), menu = $('.ch-pick__menu', wrap);
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var aberto = !menu.hidden;
      fecharMenus();
      if (aberto) return;
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var atual = $('[aria-current="true"]', menu);
      if (atual) atual.scrollIntoView({ block: 'nearest' });
    });
    menu.addEventListener('click', function (e) { e.stopPropagation(); });
  }
  function fecharMenus() {
    $$('.ch-pick__menu').forEach(function (m) { m.hidden = true; });
    $$('.ch-pick__btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  /* O pais prefere a janela do app Orbe; a lista nativa fica de reserva.
     mdApp_forceHideOrbe so trava o pop-up AUTOMATICO. */
  function tentarOrbe() {
    try {
      var modal = D.getElementById('md-app-embed__footer-popup');
      if (typeof window.mdApp_openModal === 'function' && modal) { window.mdApp_openModal('md-app-embed__footer-popup'); return true; }
      if (window.mdApp && typeof window.mdApp.openModal === 'function') { window.mdApp.openModal(); return true; }
    } catch (e) { /* segue para a lista nativa */ }
    return false;
  }
  function abrirPais() {
    if (tentarOrbe()) return;
    var btn = $('[data-ch-country] .ch-pick__btn');
    if (btn) { window.scrollTo(0, 0); btn.click(); }
  }

  /* ---------- faixa de divergencia de mercado --------------------------------------------
     Sinal: regiao do idioma do navegador; na falta, o fuso. SEM SINAL, NAO
     APARECE. So na divergencia — nunca um pop-up em todo acesso. */
  var TZ2CC = {
    'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US', 'America/Los_Angeles': 'US',
    'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'Europe/London': 'GB', 'Europe/Dublin': 'IE',
    'Europe/Lisbon': 'PT', 'Europe/Madrid': 'ES', 'Europe/Paris': 'FR', 'Europe/Berlin': 'DE',
    'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Zurich': 'CH',
    'Europe/Vienna': 'AT', 'Europe/Stockholm': 'SE', 'Europe/Oslo': 'NO', 'Europe/Copenhagen': 'DK',
    'Asia/Tokyo': 'JP', 'Asia/Seoul': 'KR', 'Asia/Dubai': 'AE', 'Asia/Riyadh': 'SA', 'Asia/Jerusalem': 'IL',
    'Asia/Qatar': 'QA', 'Asia/Kuwait': 'KW', 'Asia/Bahrain': 'BH', 'Asia/Muscat': 'OM',
    'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Pacific/Auckland': 'NZ'
  };
  function paisDoNavegador() {
    var langs = navigator.languages || [navigator.language];
    for (var i = 0; i < langs.length; i++) {
      var m = /[-_]([A-Za-z]{2})$/.exec(langs[i] || '');
      if (m) return m[1].toUpperCase();
    }
    try { var tz = Intl.DateTimeFormat().resolvedOptions().timeZone; if (tz && TZ2CC[tz]) return TZ2CC[tz]; } catch (e) { /* sem sinal */ }
    return null;
  }
  function marketHint() {
    var barra = $('[data-ch-hint]');
    if (!barra) return;
    try { if (sessionStorage.getItem('ch-hint-off') === '1') return; } catch (e) { /* segue */ }
    var atual = String(CFG.country || '').toUpperCase();
    var sinal = paisDoNavegador();
    if (!sinal || !atual || sinal === atual) return;
    var form = D.getElementById('ch-country-form');
    var alvo = form ? $('button[value="' + sinal + '"]', form) : null;
    if (!alvo) return; /* a loja nao vende para esse pais: nao oferece nada */
    var nome = $('span', alvo);
    var nomeEl = $('[data-ch-hint-name]', barra);
    if (nomeEl) nomeEl.textContent = nome ? nome.textContent : sinal;
    var ir = $('[data-ch-hint-go]', barra);
    if (ir) ir.addEventListener('click', function (e) { e.preventDefault(); alvo.click(); });
    var x = $('[data-ch-hint-x]', barra);
    if (x) x.addEventListener('click', function () {
      barra.classList.remove('is-on');
      try { sessionStorage.setItem('ch-hint-off', '1'); } catch (e) { /* so nesta visita */ }
    });
    barra.classList.add('is-on');
  }

  /* ---------- ligacao ----------------------------------------------------------------------- */
  /* =====================================================================
     v2 (22/09/2026) — o que a pagina oficial nao tem:
       Visto na pele (fotos de campanha que ja estao nas galerias dos produtos),
       Encontre seu tom (todos os tons, subtom da propria marca),
       Monte seu look (4 espacos + looks prontos do blog, desconto ao vivo),
       Do que sua make precisa (filtros por necessidade) e tons no card.
     Tudo sai dos dados que o Liquid ja entrega (ch-data) + listas do #ch-cfg.
     ===================================================================== */
  function chaveImg(k) { return String(k || '').replace(/^ch-/, 'catharine-hill-'); }
  /* imagem da galeria do produto pelo pedaco do NOME DO ARQUIVO (nao muda com o idioma) */
  function imgPorChave(p, k) {
    if (!p || !k) return null;
    var alvo = chaveImg(k);
    for (var i = 0; i < p.img.length; i++) if (String(p.img[i].s).indexOf(alvo) > -1) return p.img[i];
    return null;
  }

  /* ---------- tons no card ------------------------------------------------ */
  function corDe(p, v) { return ((CFG.sw || {})[p.h] || {})[v.t] || ''; }
  function tonsCardHTML(p) {
    if (!p.multi) return '';
    var cores = p.v.map(function (v) { return corDe(p, v); }).filter(Boolean);
    var bolas = cores.slice(0, 5).map(function (c) { return '<i style="background:' + esc(c) + '"></i>'; }).join('');
    return '<span class="ch-card__tn">' + (bolas ? '<span class="ch-card__sw" aria-hidden="true">' + bolas + '</span>' : '') +
      esc(t('tn_n').replace('{n}', fmtNum(p.v.length))) + '</span>';
  }
  function img2HTML(p) {
    var im = imgPorChave(p, (CFG.hov || {})[p.h]);
    if (!im) return '';
    return '<img class="ch-card__img2" src="' + esc(imgW(im.s, 450)) + '" srcset="' + esc(srcset(im.s)) + '" sizes="(max-width:767px) 46vw, 283px" alt="" loading="lazy" decoding="async" width="600" height="600">';
  }

  /* ---------- Visto na pele ------------------------------------------------ */
  var SEEN_INI = null;
  function renderSeen() {
    var ul = $('[data-ch-seen]');
    if (!ul) return;
    var cel = CEL && CEL.matches;
    var ini = cel ? 9 : 14;
    var tiles = (CFG.tiles || []).map(function (x) {
      var p = porHandle(x.h);
      var im = p && imgPorChave(p, x.k);
      return im ? { p: p, im: im } : null;
    }).filter(Boolean);
    var sec = $('#ch-seen');
    if (sec) sec.hidden = !tiles.length;
    ul.innerHTML = tiles.map(function (x, i) {
      var nome = nomeCard(x.p);
      return '<li class="ch-seen__it' + (i >= ini && SEEN_INI !== 'all' ? ' is-more' : '') + '">' +
        '<a href="' + esc((CFG.root || '') + '/products/' + x.p.h) + '" data-ch-open-handle="' + esc(x.p.h) + '" aria-label="' + esc(nome) + '">' +
        '<img src="' + esc(imgW(x.im.s, 600)) + '" srcset="' + esc([300, 450, 600, 900].map(function (w) { return imgW(x.im.s, w) + ' ' + w + 'w'; }).join(', ')) + '"' +
        ' sizes="(max-width:767px) 50vw, 25vw" alt="' + esc(x.im.a || nome) + '" loading="lazy" decoding="async" width="600" height="600">' +
        '<span class="ch-seen__cap"><b>' + esc(nome) + '</b><i aria-hidden="true">→</i></span></a></li>';
    }).join('');
    var mais = $('[data-ch-seen-more]');
    if (mais) mais.hidden = SEEN_INI === 'all' || tiles.length <= ini;
  }

  /* ---------- Encontre seu tom -------------------------------------------- */
  var UT = ['pink', 'neutral', 'yellow', 'olive', 'orange', 'red'];
  /* subtom pelo NOME DO ARQUIVO da foto da variante ("...-a6-orange-red-undertone-..."):
     e o que a marca/cadastro diz de cada tom, e nao muda com o idioma */
  function subtom(v) {
    var m = /\/([^\/?]+)\?/.exec(String(v.im || '') + '?');
    var nome = m ? m[1] : '';
    var i = nome.indexOf('-undertone');
    if (i < 0) return [];
    var partes = nome.slice(0, i).split('-'), out = [];
    for (var k = partes.length - 1; k >= 0 && UT.indexOf(partes[k]) > -1; k--) out.unshift(partes[k]);
    return out;
  }
  var TONS = { tab: null, ut: {}, sel: null };
  function tonsTabs() { return (CFG.tons || []).filter(function (g) { return g[1].some(function (x) { return porHandle(x[0]); }); }); }
  function chipHTML(p, v) {
    var cor = corDe(p, v), uts = subtom(v);
    /* tom sem foto propria, num produto em que os outros tons tem foto: usa a foto do produto (a bolinha nao some) */
    var foto = v.im || (p.v.some(function (x) { return x.im; }) && p.img[0] ? p.img[0].s : '');
    var sw = cor ? '<span class="ch-chip__sw" style="background:' + esc(cor) + '"></span>' :
      (foto ? '<span class="ch-chip__sw ch-chip__sw--img" style="background-image:url(' + esc(imgW(foto, 160)) + ')"></span>' : '');
    var dica = v.t + (uts.length ? ' · ' + t('st_ut_is').replace('{u}', uts.map(function (u) { return t('ut_' + u); }).join(' / ')) : '');
    return '<li><button type="button" class="ch-chip' + (sw ? '' : ' ch-chip--txt') + (v.av ? '' : ' is-out') + '" data-ch-tone="' + v.id + '" data-ch-tone-h="' + esc(p.h) + '"' +
      ' data-ut="' + esc(uts.join(' ')) + '" aria-pressed="false" title="' + esc(dica) + '">' + sw + '<span class="ch-chip__t">' + esc(v.t) + '</span></button></li>';
  }
  function grupoHTML(p, escala) {
    var uts = {};
    p.v.forEach(function (v) { subtom(v).forEach(function (u) { uts[u] = 1; }); });
    var lista = UT.filter(function (u) { return uts[u]; });
    var filtro = lista.length ? '<div class="ch-utf" role="group" aria-label="' + esc(t('st_ut')) + '"><span>' + esc(t('st_ut')) + '</span>' +
      ['all'].concat(lista).map(function (u) {
        var on = (TONS.ut[p.h] || 'all') === u;
        return '<button type="button" data-ch-ut="' + u + '" data-ch-ut-h="' + esc(p.h) + '" aria-pressed="' + on + '">' + esc(u === 'all' ? t('st_all') : t('ut_' + u)) + '</button>';
      }).join('') + '</div>' : '';
    return '<div class="ch-tg" data-ch-tg="' + esc(p.h) + '">' +
      '<div class="ch-tg__head"><h3>' + esc(nomeCard(p)) + '</h3><span>' + esc(t('st_n').replace('{n}', fmtNum(p.v.length))) + '</span></div>' +
      filtro +
      (escala ? '<div class="ch-tg__scale" aria-hidden="true"><span>' + esc(t('st_light')) + '</span><i></i><span>' + esc(t('st_deep')) + '</span></div>' : '') +
      '<ul class="ch-tg__chips">' + p.v.map(function (v) { return chipHTML(p, v); }).join('') + '</ul></div>';
  }
  function renderTons() {
    var main = $('[data-ch-tons-main]');
    if (!main) return;
    var abas = tonsTabs();
    var sec = $('#ch-tons');
    if (sec) sec.hidden = !abas.length;
    if (!abas.length) return;
    if (!TONS.tab || !abas.some(function (g) { return g[0] === TONS.tab; })) TONS.tab = abas[0][0];
    $$('[data-ch-tons-tab]').forEach(function (b) {
      var ok = abas.some(function (g) { return g[0] === b.dataset.chTonsTab; });
      b.hidden = !ok;
      var on = b.dataset.chTonsTab === TONS.tab;
      b.classList.toggle('is-on', on); b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1;
    });
    var g = abas.filter(function (x) { return x[0] === TONS.tab; })[0];
    main.innerHTML = g[1].map(function (x) { var p = porHandle(x[0]); return p ? grupoHTML(p, !!x[1]) : ''; }).join('');
    aplicaUT();
    pintaEscolha();
  }
  function aplicaUT() {
    $$('[data-ch-tg]').forEach(function (grp) {
      var u = TONS.ut[grp.dataset.chTg] || 'all';
      $$('[data-ch-tone]', grp).forEach(function (b) {
        var bate = u === 'all' || (' ' + b.dataset.ut + ' ').indexOf(' ' + u + ' ') > -1;
        b.classList.toggle('is-dim', !bate);
      });
      $$('[data-ch-ut]', grp).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.chUt === u)); });
    });
  }
  function pintaEscolha() {
    var box = $('[data-ch-tons-pick]');
    if (!box) return;
    $$('[data-ch-tone]').forEach(function (b) { b.setAttribute('aria-pressed', String(!!TONS.sel && Number(b.dataset.chTone) === Number(TONS.sel.v.id))); });
    var sel = TONS.sel;
    if (!sel || !$('[data-ch-tg="' + sel.p.h + '"]')) {
      var g = $('[data-ch-tg]'), p = g && porHandle(g.dataset.chTg), im = p && p.img[0];
      box.innerHTML = (im ? '<div class="ch-tp__img"><img src="' + esc(imgW(im.s, 600)) + '" alt="" loading="lazy" width="600" height="600"></div>' : '') +
        '<p class="ch-tp__empty">' + esc(t('st_pick')) + '</p>';
      return;
    }
    var p2 = sel.p, v = sel.v, uts = subtom(v), cor = corDe(p2, v);
    var foto = v.im || (p2.img[0] || {}).s;
    box.innerHTML =
      '<div class="ch-tp__img">' + (foto ? '<img src="' + esc(imgW(foto, 600)) + '" alt="' + esc(p2.t + ' — ' + v.t) + '" width="600" height="600">' : '') +
        (cor ? '<span class="ch-tp__sw" style="background:' + esc(cor) + '"></span>' : '') + '</div>' +
      '<p class="ch-tp__p">' + esc(nomeCard(p2)) + '</p>' +
      '<h3 class="ch-tp__t">' + esc(v.t) + '</h3>' +
      (uts.length ? '<p class="ch-tp__u">' + esc(t('st_ut_is').replace('{u}', uts.map(function (u) { return t('ut_' + u); }).join(' / '))) + '</p>' : '') +
      '<p class="ch-tp__pr"><b>' + esc(v.prf) + '</b></p>' +
      '<button type="button" class="ch-btn ch-btn--block" data-ch-add="' + v.id + '"' + (v.av ? '' : ' disabled') + '>' + esc(v.av ? t('st_add').replace('{s}', v.t) : t('soldout')) + '</button>' +
      '<button type="button" class="ch-lnk ch-tp__det" data-ch-tone-pdp="' + esc(p2.h) + '" data-v="' + v.id + '">' + esc(t('st_det')) + '</button>';
  }

  /* ---------- Monte seu look ----------------------------------------------- */
  var LOOK = [null, null, null, null]; /* {p, v|null} */
  function lookN() { return LOOK.filter(Boolean).length; }
  function slotPrecisaTom(s) { return s && s.p.multi && !s.v; }
  function precoSlot(s) { var v = s.v || s.p.min; return v.pr; }
  function passos() { return (CFG.steps || []).slice().sort(function (a, b) { return a.q - b.q; }); }
  function renderLook() {
    var ol = $('[data-ch-slots]');
    if (!ol) return;
    var sec = $('#ch-look');
    if (sec) sec.hidden = !PRODUCTS.length;
    var base = CART.count;
    ol.innerHTML = LOOK.map(function (s, i) {
      if (!s) {
        var at = degrauDe(base + i + 1);
        return '<li class="ch-slot"><button type="button" class="ch-slot__add" data-ch-slot-add="' + i + '"><span class="ch-slot__plus" aria-hidden="true">+</span>' +
          '<span>' + esc(t('lk_empty')) + '</span>' + (at ? '<small>−' + at.p + '%</small>' : '') + '</button></li>';
      }
      var p = s.p, im = (s.v && s.v.im) || (p.img[0] || {}).s;
      var sel = p.multi ? '<select class="ch-slot__sel" data-ch-slot-var="' + i + '" aria-label="' + esc(t('lk_shade') + ' — ' + nomeCard(p)) + '">' +
        '<option value="">' + esc(t('lk_shade')) + '</option>' +
        p.v.map(function (v) { return '<option value="' + v.id + '"' + (s.v && s.v.id === v.id ? ' selected' : '') + (v.av ? '' : ' disabled') + '>' + esc(v.t) + '</option>'; }).join('') + '</select>' : '';
      return '<li class="ch-slot is-full' + (slotPrecisaTom(s) ? ' is-need' : '') + '">' +
        '<span class="ch-slot__img">' + (im ? '<img src="' + esc(imgW(im, 160)) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="ch-slot__body"><b>' + esc(nomeCard(p)) + '</b>' + sel + '<span class="ch-slot__pr">' + esc((s.v || p.min).prf) + '</span></span>' +
        '<button type="button" class="ch-slot__x" data-ch-slot-rm="' + i + '" aria-label="' + esc(t('lk_rm') + ' — ' + nomeCard(p)) + '">&times;</button></li>';
    }).join('');
    var n = lookN(), total = base + n, at = degrauDe(total);
    var nEl = $('[data-ch-look-n]');
    if (nEl) nEl.textContent = t('lk_n').replace('{n}', n);
    /* medidor: os degraus do Pumper, contando o que ja esta no carrinho */
    var ps = passos(), prox = ps.filter(function (s) { return s.q > total; })[0];
    var msg = $('[data-ch-look-msg]');
    if (msg) {
      if (!n) msg.textContent = '';
      else if (prox) msg.textContent = t('lk_next').replace('{n}', prox.q - total).replace('{p}', prox.p);
      else msg.textContent = t('lk_max').replace('{p}', (ps[ps.length - 1] || {}).p || '');
    }
    $$('[data-ch-look-meter] li').forEach(function (li) { li.classList.toggle('is-on', total >= Number(li.dataset.q)); });
    var sub = LOOK.filter(Boolean).reduce(function (a, s) { return a + precoSlot(s); }, 0);
    var pct = at ? at.p : 0, off = Math.round(sub * pct / 100);
    var set = function (k, v) { var el = $('[data-ch-look-' + k + ']'); if (el) el.textContent = v; };
    set('sub', money(sub));
    set('off', pct ? '−' + money(off) + ' (' + pct + '%)' : '—');
    set('tot', money(sub - off));
    var falta = LOOK.some(slotPrecisaTom);
    var need = $('[data-ch-look-need]');
    if (need) need.hidden = !falta;
    var add = $('[data-ch-look-add]');
    if (add) add.disabled = !n || falta || LOOK.some(function (s) { return s && !(s.v || s.p.min).av; });
    var clr = $('[data-ch-look-clear]');
    if (clr) clr.hidden = !n;
    $$('[data-ch-look-use]').forEach(function (b) {
      var L = (CFG.looks || []).filter(function (x) { return String(x.id) === b.dataset.chLookUse; })[0];
      var ok = L && L.h.some(function (h) { var p = porHandle(h); return p && p.av; });
      var li = b.closest('li');
      if (li) li.hidden = !ok;
    });
  }
  function renderLooks() {
    (CFG.looks || []).forEach(function (L) {
      var capa = $('[data-ch-lk-cover="' + L.id + '"]');
      var cp = porHandle(L.c && L.c[0]), im = imgPorChave(cp, L.c && L.c[1]) || (cp && cp.img[0]);
      if (capa) capa.innerHTML = im ? '<img src="' + esc(imgW(im.s, 600)) + '" srcset="' + esc(srcset(im.s)) + '" sizes="(max-width:767px) 70vw, 280px" alt="" loading="lazy" width="600" height="600">' : '';
      var th = $('[data-ch-lk-thumbs="' + L.id + '"]');
      if (th) th.innerHTML = L.h.map(porHandle).filter(Boolean).map(function (p) {
        var s = (p.img[0] || {}).s;
        return '<span title="' + esc(nomeCard(p)) + '">' + (s ? '<img src="' + esc(imgW(s, 120)) + '" alt="' + esc(nomeCard(p)) + '" loading="lazy" width="60" height="60">' : '') + '</span>';
      }).join('');
    });
  }
  function usaLook(id) {
    var L = (CFG.looks || []).filter(function (x) { return String(x.id) === String(id); })[0];
    if (!L) return;
    var lista = L.h.map(porHandle).filter(function (p) { return p && p.av; }).slice(0, 4);
    LOOK = [0, 1, 2, 3].map(function (i) {
      var p = lista[i];
      if (!p) return null;
      /* NUNCA escolher o tom pela pessoa: produto com tons entra sem tom */
      return { p: p, v: p.multi ? null : p.min };
    });
    renderLook();
    var box = $('[data-ch-look-box]');
    if (box && box.getBoundingClientRect().top > innerHeight - 80) box.scrollIntoView({ behavior: REDUZ ? 'auto' : 'smooth', block: 'start' });
    var s1 = $('.ch-slot.is-need select');
    if (s1) setTimeout(function () { try { s1.focus({ preventScroll: true }); } catch (e) { s1.focus(); } }, 350);
  }
  var LPICK = { slot: 0, fam: 'all' };
  var lpickEl, lpickVeil;
  function lpickLista() {
    return todosEmOrdem().filter(function (p) { return p.av && passaFiltro(p, LPICK.fam); });
  }
  function renderLpick() {
    if (!lpickEl) return;
    $$('[data-ch-lp-fam]', lpickEl).forEach(function (b) {
      var k = b.dataset.chLpFam;
      b.hidden = k !== 'all' && !todosEmOrdem().some(function (p) { return p.av && passaFiltro(p, k); });
      var on = k === LPICK.fam;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on));
    });
    var ja = LOOK.filter(Boolean).map(function (s) { return s.p.h; });
    var ul = $('[data-ch-lp-list]', lpickEl);
    if (ul) ul.innerHTML = lpickLista().map(function (p) {
      var s = (p.img[0] || {}).s, dentro = ja.indexOf(p.h) > -1;
      return '<li><span class="ch-lp__img">' + (s ? '<img src="' + esc(imgW(s, 160)) + '" alt="" width="56" height="56">' : '') + '</span>' +
        '<span class="ch-lp__t"><b>' + esc(nomeCard(p)) + '</b><span>' + precoHTML(p).replace(/<\/?b>/g, '') + (p.multi ? ' · ' + esc(t('tn_n').replace('{n}', fmtNum(p.v.length))) : '') + '</span></span>' +
        '<button type="button" class="ch-btn ch-btn--sm' + (dentro ? ' ch-btn--ghost' : '') + '" data-ch-lp-put="' + esc(p.h) + '"' + (dentro ? ' disabled' : '') + '>' + esc(t('lk_put')) + '</button></li>';
    }).join('');
  }
  function abrirLpick(slot) {
    if (!lpickEl) return;
    LPICK.slot = slot;
    lastFocus = D.activeElement;
    renderLpick();
    lpickEl.classList.add('is-on'); lpickEl.setAttribute('aria-hidden', 'false');
    if (lpickVeil) { lpickVeil.hidden = false; requestAnimationFrame(function () { lpickVeil.classList.add('is-on'); }); }
    travarRolagem();
    var x = $('[data-ch-lp-close]', lpickEl); if (x) x.focus();
  }
  function fecharLpick() {
    if (!lpickEl || !lpickEl.classList.contains('is-on')) return;
    lpickEl.classList.remove('is-on'); lpickEl.setAttribute('aria-hidden', 'true');
    if (lpickVeil) { lpickVeil.classList.remove('is-on'); setTimeout(function () { lpickVeil.hidden = true; }, 220); }
    destravarRolagem();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function poeNoLook(h) {
    var p = porHandle(h);
    if (!p) return;
    var i = LOOK[LPICK.slot] ? LOOK.indexOf(null) : LPICK.slot;
    if (i < 0) i = LPICK.slot;
    LOOK[i] = { p: p, v: p.multi ? null : p.min };
    fecharLpick();
    renderLook();
    var sel = $('[data-ch-slot-var="' + i + '"]');
    if (sel) setTimeout(function () { sel.focus(); }, 60);
  }
  function addLook(btn) {
    var itens = LOOK.filter(Boolean).map(function (s) { return { id: Number((s.v || s.p.min).id), quantity: 1 }; });
    if (!itens.length) return;
    var rotulo = btn.innerHTML;
    btn.disabled = true; btn.textContent = t('adding');
    fetch(cartURL('/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: itens })
    })
      .then(function (r) { if (!r.ok) throw new Error('look ' + r.status); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        btn.innerHTML = rotulo;
        LOOK = [null, null, null, null];
        renderLook();
        toast(t('lk_done'));
        openCart();
      })
      .catch(function (e) {
        console.error('[catharine-hill] look', e);
        btn.innerHTML = rotulo; btn.disabled = false;
        toast(t('err_add'));
      });
  }

  /* ---------- Do que sua make precisa? -------------------------------------- */
  var NEED = { wp: 1, cov: 1, matte: 1, lum: 1, multi: 1 };
  function contaNeeds() {
    $$('[data-ch-need-n]').forEach(function (el) {
      var n = listaFiltro(el.dataset.chNeedN).length;
      el.textContent = n ? fmtNum(n) : '';
      var li = el.closest('li');
      if (li) li.hidden = !n;
    });
    $$('.ch-need').forEach(function (b) { b.classList.toggle('is-on', b.dataset.chFilter === FILTRO); });
  }
  function renderV2() {
    renderSeen();
    renderTons();
    renderLooks();
    renderLook();
    contaNeeds();
  }
  function ligaV2() {
    lpickEl = $('[data-ch-lpick]'); lpickVeil = $('[data-ch-lpick-veil]');
    var abasT = $$('[data-ch-tons-tab]');
    abasT.forEach(function (b) {
      b.addEventListener('click', function () { TONS.tab = b.dataset.chTonsTab; renderTons(); });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var vis = abasT.filter(function (x) { return !x.hidden; }), i = vis.indexOf(b);
        var alvo = vis[(i + (e.key === 'ArrowRight' ? 1 : -1) * (RTL ? -1 : 1) + vis.length) % vis.length];
        if (alvo) { e.preventDefault(); TONS.tab = alvo.dataset.chTonsTab; renderTons(); alvo.focus(); }
      });
    });
    D.addEventListener('change', function (e) {
      var sel = e.target && e.target.closest && e.target.closest('[data-ch-slot-var]');
      if (!sel) return;
      var s = LOOK[Number(sel.dataset.chSlotVar)];
      if (!s) return;
      s.v = s.p.v.filter(function (v) { return String(v.id) === sel.value; })[0] || null;
      var foco = sel.dataset.chSlotVar;
      renderLook();
      var n = $('[data-ch-slot-var="' + foco + '"]'); if (n) n.focus();
    });
    /* troca de celular/computador muda quantas fotos aparecem de inicio */
    if (CEL) { var re = function () { renderSeen(); }; if (CEL.addEventListener) CEL.addEventListener('change', re); else if (CEL.addListener) CEL.addListener(re); }
    cabeNav();
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(cabeNav);
    var rn; window.addEventListener('resize', function () { clearTimeout(rn); rn = setTimeout(cabeNav, 120); });
  }
  /* Cabecalho: o logo fica no CENTRO. Se o menu (Produtos + os dois atalhos da v2)
     encostar no logo — alemao, frances, telas de ~1100 px — os atalhos saem um a um
     (continuam no menu lateral). */
  function cabeNav() {
    var nav = $('.ch-nav'), logo = $('.ch-brand');
    if (!nav || !logo) return;
    var itens = $$('[data-ch-nav-opt]', nav).sort(function (a, b) { return Number(a.dataset.chNavOpt) - Number(b.dataset.chNavOpt); });
    itens.forEach(function (li) { li.hidden = false; });
    var bate = function () {
      var n = nav.getBoundingClientRect(), l = logo.getBoundingClientRect();
      if (!n.width) return false;
      return RTL ? n.left < l.right + 24 : n.right > l.left - 24;
    };
    for (var i = 0; i < itens.length && bate(); i++) itens[i].hidden = true;
  }
  /* cliques da v2 — chamado no clique global ANTES do card */
  function cliqueV2(e, alvo) {
    var b;
    if ((b = alvo.closest('[data-ch-tone]'))) {
      e.preventDefault();
      var p = porHandle(b.dataset.chToneH);
      var v = p && p.v.filter(function (x) { return String(x.id) === b.dataset.chTone; })[0];
      if (v) { TONS.sel = { p: p, v: v }; pintaEscolha(); if (CEL && CEL.matches) { var bx = $('[data-ch-tons-pick]'); if (bx) bx.scrollIntoView({ behavior: REDUZ ? 'auto' : 'smooth', block: 'nearest' }); } }
      return true;
    }
    if ((b = alvo.closest('[data-ch-ut]'))) { e.preventDefault(); TONS.ut[b.dataset.chUtH] = b.dataset.chUt; aplicaUT(); return true; }
    if ((b = alvo.closest('[data-ch-tone-pdp]'))) { e.preventDefault(); openPDP(b.dataset.chTonePdp, b.dataset.v); return true; }
    if ((b = alvo.closest('[data-ch-seen-more]'))) { e.preventDefault(); SEEN_INI = 'all'; $$('.ch-seen__it.is-more').forEach(function (li) { li.classList.remove('is-more'); }); b.hidden = true; return true; }
    if ((b = alvo.closest('[data-ch-look-use]'))) { e.preventDefault(); usaLook(b.dataset.chLookUse); return true; }
    if ((b = alvo.closest('[data-ch-slot-add]'))) { e.preventDefault(); abrirLpick(Number(b.dataset.chSlotAdd)); return true; }
    if ((b = alvo.closest('[data-ch-slot-rm]'))) { e.preventDefault(); LOOK[Number(b.dataset.chSlotRm)] = null; renderLook(); return true; }
    if ((b = alvo.closest('[data-ch-look-clear]'))) { e.preventDefault(); LOOK = [null, null, null, null]; renderLook(); return true; }
    if ((b = alvo.closest('[data-ch-look-add]'))) { e.preventDefault(); if (!b.disabled) addLook(b); return true; }
    if ((b = alvo.closest('[data-ch-lp-fam]'))) { e.preventDefault(); LPICK.fam = b.dataset.chLpFam; renderLpick(); return true; }
    if ((b = alvo.closest('[data-ch-lp-put]'))) { e.preventDefault(); poeNoLook(b.dataset.chLpPut); return true; }
    if (alvo.closest('[data-ch-lp-close]') || alvo.closest('[data-ch-lpick-veil]')) { fecharLpick(); return true; }
    return false;
  }

  function init() {
    $$('[data-ch-grid]').forEach(function (g) { g.setAttribute('aria-busy', 'true'); });

    cartEl = $('[data-ch-cart]'); veilEl = $('[data-ch-cart-veil]'); bodyEl = $('[data-ch-cart-body]');
    footEl = $('[data-ch-cart-foot]'); totalEl = $('[data-ch-cart-total]'); countEl = $('[data-ch-count]');
    qdEl = $('[data-ch-cart-qd]'); shipEl = $('[data-ch-cart-ship]');
    pdpOvl = $('[data-ch-pdp-ovl]'); pdpBox = $('[data-ch-pdp]');
    postOvl = $('[data-ch-post-ovl]'); postBox = $('[data-ch-post-box]');
    menuEl = $('[data-ch-menu]'); menuVeil = $('[data-ch-menu-veil]');

    ligaCabecalho();
    ligaEncaixe();
    ligaHero();
    ligaBusca();
    ligaAbas();
    ligaV2();
    renderGrids();
    bindPicker($('[data-ch-lang]'));
    bindPicker($('[data-ch-country]'));
    D.body.classList.toggle('ch-has-cart', CART.count > 0);
    markStep();

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { $$('.ch-rail').forEach(atualizaRail); }, 150);
    });

    var btnPais = $('[data-ch-country] .ch-pick__btn');
    if (btnPais) btnPais.addEventListener('click', function (e) {
      if (tentarOrbe()) { e.stopImmediatePropagation(); fecharMenus(); }
    }, true);

    D.addEventListener('click', fecharMenus);

    /* Clique global. A ORDEM importa: controles internos da ficha, depois
       botoes de compra, depois o card (que tambem responde ao clique). */
    D.addEventListener('click', function (e) {
      var alvo = e.target;
      if (!alvo || !alvo.closest) return;

      var opt = alvo.closest('[data-ch-var]');
      if (opt) {
        e.preventDefault(); e.stopPropagation();
        if (opt.disabled || !PDP.p) return;
        var nova = PDP.p.v.filter(function (v) { return Number(v.id) === Number(opt.dataset.chVar); })[0];
        if (nova) { PDP.v = nova; pintarVariante(true); }
        return;
      }
      var passo = alvo.closest('[data-ch-pdp-step]');
      if (passo) { e.preventDefault(); e.stopPropagation(); porQtdPDP(pdpQtd() + Number(passo.dataset.chPdpStep)); return; }
      if (cliqueV2(e, alvo)) return;

      var add = alvo.closest('[data-ch-add]');
      if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add.dataset.chAdd, false, add, add.closest('.ch-pdp') ? pdpQtd() : 1); return; }
      var buy = alvo.closest('[data-ch-buy]');
      if (buy) { e.preventDefault(); e.stopPropagation(); addToCart(buy.dataset.chBuy, true, buy, buy.closest('.ch-pdp') ? pdpQtd() : 1); return; }

      /* circulos, cartoes, menu e rodape: escolhem a aba da vitrine; a ancora rola */
      var filtro = alvo.closest('[data-ch-filter]');
      if (filtro) { setFiltro(filtro.dataset.chFilter); fecharMenu(); return; }
      var ir = alvo.closest('[data-ch-menu-go],[data-ch-go]');
      if (ir && !ir.hasAttribute('data-ch-open-handle')) { fecharMenu(); return; }

      /* abrir ficha (slides, busca, rodape, blog). Produto fora do mercado:
         deixa o link seguir para a pagina do produto. */
      var abre = alvo.closest('[data-ch-open-handle]');
      if (abre) {
        if (porHandle(abre.dataset.chOpenHandle)) { e.preventDefault(); e.stopPropagation(); fecharBusca(); openPDP(abre.dataset.chOpenHandle); }
        else fecharMenu();
        return;
      }

      var post = alvo.closest('[data-ch-post]');
      if (post) { e.preventDefault(); abrirPost(post.dataset.chPost); return; }
      if (alvo.closest('[data-ch-post-close]') || alvo === postOvl) { fecharPost(); return; }

      var termo = alvo.closest('[data-ch-term]');
      if (termo) { e.preventDefault(); abrirBusca(termo.dataset.chTerm); return; }

      var card = alvo.closest('.ch-card');
      if (card && card.dataset.chHandle) { openPDP(card.dataset.chHandle); return; }

      if (alvo.closest('[data-ch-search-open]')) { abrirBusca(); return; }
      if (alvo.closest('[data-ch-search-close]') || alvo.closest('[data-ch-search-veil]')) { fecharBusca(); return; }
      if (alvo.closest('[data-ch-menu-open]')) { abrirMenu(); return; }
      if (alvo.closest('[data-ch-menu-close]') || alvo.closest('[data-ch-menu-veil]')) { fecharMenu(); return; }
      if (alvo.closest('[data-ch-nostock-country]')) { abrirPais(); return; }
      if (alvo.closest('[data-ch-cart-open]')) { openCart(); return; }
      if (alvo.closest('[data-ch-cart-close]') || alvo.closest('[data-ch-cart-veil]')) { closeCart(); return; }
      if (alvo.closest('[data-ch-pdp-close]') || alvo === pdpOvl) { closePDP(); return; }

      var th = alvo.closest('[data-ch-th]');
      if (th) {
        var i = Number(th.dataset.chTh), main = $('[data-ch-main]');
        if (PDP.p && main && PDP.p.img[i]) {
          main.src = imgW(PDP.p.img[i].s, 900);
          main.alt = PDP.p.img[i].a || PDP.p.t;
          $$('[data-ch-th]').forEach(function (b) { b.removeAttribute('aria-current'); });
          th.setAttribute('aria-current', 'true');
        }
        return;
      }
      var qty = alvo.closest('[data-ch-qty]');
      if (qty) {
        var linhaEl = qty.closest('.ch-line');
        var atual = CART.items.filter(function (it) { return it.key === linhaEl.dataset.key; })[0];
        if (atual) changeQty(atual.key, atual.quantity + Number(qty.dataset.chQty));
        return;
      }
      var rm = alvo.closest('[data-ch-rm]');
      if (rm) { var l2 = rm.closest('.ch-line'); if (l2) changeQty(l2.dataset.key, 0); }
    });

    /* Teclado. O popup da garantia e um checkbox: o Escape fecha SO ele quando
       estiver aberto. <label role="button"> nao responde a Enter/Espaco
       sozinho — o navegador so liga label e controle no clique. */
    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var cbx = D.getElementById('ch-guar-cbx');
        if (cbx && cbx.checked) { cbx.checked = false; return; }
        if (lpickEl && lpickEl.classList.contains('is-on')) { fecharLpick(); return; }
        closePDP(); fecharPost(); closeCart(); fecharBusca(); fecharMenu(); fecharMenus(); return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target;
      if (!el || !el.closest) return;
      var lbl = el.closest('label[for="ch-guar-cbx"]');
      if (lbl) { e.preventDefault(); var c = D.getElementById('ch-guar-cbx'); if (c) c.checked = !c.checked; return; }
      var card = el.closest('.ch-card');
      if (card && card === el && card.dataset.chHandle) { e.preventDefault(); openPDP(card.dataset.chHandle); }
    });

    /* O resto do catalogo e o carrinho descem EM PARALELO, depois da primeira pintura. */
    carregarResto();
    fetchCart().then(marketHint);
    /* Quem volta de outra aba ou do checkout (botao Voltar) ve o carrinho ATUAL, nao o de antes. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart(); });
    D.addEventListener('visibilitychange', function () { if (!D.hidden) fetchCart(); });
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();
})();
